import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const TENSION_LABELS = {
  SELF_vs_OTHER: ['Self', 'Other'],
  APPROACH_vs_AVOID: ['Approach', 'Avoid'],
  CONTROL_vs_RELEASE: ['Control', 'Release'],
  INDIVIDUAL_vs_COLLECTIVE: ['Individual', 'Collective'],
  CONCRETE_vs_ABSTRACT: ['Concrete', 'Abstract'],
};

const TENSION_COLORS = {
  SELF_vs_OTHER: ['hsl(280, 70%, 60%)', 'hsl(200, 70%, 60%)'],
  APPROACH_vs_AVOID: ['hsl(160, 70%, 50%)', 'hsl(0, 70%, 60%)'],
  CONTROL_vs_RELEASE: ['hsl(220, 70%, 60%)', 'hsl(45, 80%, 55%)'],
  INDIVIDUAL_vs_COLLECTIVE: ['hsl(330, 60%, 55%)', 'hsl(170, 60%, 50%)'],
  CONCRETE_vs_ABSTRACT: ['hsl(30, 70%, 55%)', 'hsl(260, 60%, 60%)'],
};

export default function TensionSpectrum({ tensions = [] }) {
  if (tensions.length === 0) {
    return (
      <div className="text-sm text-muted-foreground text-center py-4">
        No tension data yet
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {tensions.map((tension) => {
        const labels = TENSION_LABELS[tension.axis] || [tension.axis, ''];
        const colors = TENSION_COLORS[tension.axis] || ['hsl(var(--primary))', 'hsl(var(--primary))'];
        // average_position is -1 to +1, map to 0-100%
        const position = ((tension.average_position + 1) / 2) * 100;

        return (
          <div key={tension.axis} className="space-y-1">
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>{labels[0]}</span>
              <span>{labels[1]}</span>
            </div>
            <div className="relative h-2 rounded-full overflow-hidden bg-muted">
              {/* Gradient bar */}
              <div
                className="absolute inset-0 rounded-full opacity-40"
                style={{
                  background: `linear-gradient(to right, ${colors[0]}, hsl(var(--muted)) 50%, ${colors[1]})`,
                }}
              />
              {/* Position marker */}
              <div
                className="absolute top-1/2 -translate-y-1/2 h-3.5 w-1.5 rounded-full bg-foreground shadow-sm transition-all duration-500"
                style={{ left: `calc(${position}% - 3px)` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
